import { initReactI18next, useTranslation } from 'react-i18next';
import i18next from 'i18next';
import ChainedBackend from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import ICU from 'i18next-icu';
import resourcesToBackend from 'i18next-resources-to-backend';

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

// =================================

var assetPathsPromise;
function getAssetPath() {
  if (!assetPathsPromise) {
    assetPathsPromise = fetch('https://translations.mapado.net/asset_paths.json').then(function (response) {
      return response.json();
    });
  }
  return assetPathsPromise;
}
function getI18NextInstance(projectName, namespaceList, defaultNamespace, languageList, defaultLanguage, backendLoader) {
  var extraConfig = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {
    postProcess: undefined,
    useHttpBackend: true
  };
  var dynamicImportBackend = resourcesToBackend(function (language, namespace, callback) {
    return backendLoader(language, namespace).then(function (_ref) {
      var resources = _ref["default"];
      callback(null, resources);
    })["catch"](function (error) {
      callback(error, null);
    });
  });
  var httpBackend = new HttpApi(null, {
    crossDomain: false,
    // allow loading from translations.mapado.net
    loadPath: function loadPath(languages, namespaces) {
      var lng = languages[0];
      var ns = namespaces[0];
      if (languageList.indexOf(lng) === -1) {
        return Promise.resolve('https://translations.mapado.net/404');
        // should be handled in the .catch() here : https://github.com/i18next/i18next-http-backend/blob/master/lib/index.js#L61-L64
        // return Promise.reject(new Error(`Unknown language: ${lng}`));
      }
      return getAssetPath().then(function (assetPaths) {
        return "https://translations.mapado.net/".concat(assetPaths["".concat(projectName, ".").concat(ns, ".").concat(lng, ".json")]);
      })["catch"](function () {
        // should be handled in the .catch() here : https://github.com/i18next/i18next-http-backend/blob/master/lib/index.js#L61-L64
        return 'https://translations.mapado.net/404';
      });
    }
  });
  var i18nInstance = i18next.createInstance();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var backend;
  if (process.env.NODE_ENV === 'test') {
    backend = undefined;
  } else if (extraConfig.useHttpBackend === false) {
    backend = {
      backends: [dynamicImportBackend]
    };
  } else {
    backend = {
      backends: [httpBackend, dynamicImportBackend]
    };
  }
  i18nInstance.use(ICU).use(initReactI18next) // passes i18next down to react-i18next
  .use(ChainedBackend).init({
    ns: namespaceList,
    // admin should be loaded explicitly when needed, See https://www.i18next.com/principles/namespaces#sample
    defaultNS: defaultNamespace,
    backend: backend,
    resources: process.env.NODE_ENV === 'test' ? _defineProperty({}, defaultLanguage, _defineProperty({}, defaultNamespace, {})) : undefined,
    lng: defaultLanguage,
    // if you're using a language detector, do not define the lng option
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    postProcess: extraConfig.postProcess
  });
  return i18nInstance;
}

function createI18nPack() {
  var i18n = getI18NextInstance.apply(void 0, arguments);
  function useTranslation$1(ns, options) {
    return useTranslation(ns, _objectSpread2(_objectSpread2({}, options), {}, {
      i18n: i18n
    }));
  }
  return {
    i18n: i18n,
    useTranslation: useTranslation$1
  };
}

/** @deprecated use createI18nPack instead */
var deprecatedGetI18NextInstance = getI18NextInstance;

export { createI18nPack, deprecatedGetI18NextInstance as getI18NextInstance };
//# sourceMappingURL=index.js.map
